<div class="questions-button" [class.visible]="isVisible" (click)="openDialog()">
    <mat-icon>assignment</mat-icon><span>Burning questions</span>
</div>
<div class="live-chat-button visible">
    <mat-icon>message</mat-icon><span>Live chat</span>
</div>